import { render, staticRenderFns } from "./BranchesSection.vue?vue&type=template&id=5a1af335"
import script from "./BranchesSection.vue?vue&type=script&lang=js"
export * from "./BranchesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports